<template>
    <div style="box-shadow: 0px 0px 4px #999999 ;">

        <div style="padding: 15px">
            <div>
<!--                <van-cell style="padding-left: 0px">-->
<!--                    <van-image slot="icon" :src="shareIcon" round style="width: 40px; height: 40px; margin-right: 8px;" />-->
<!--                    <div slot="title" style="font-size: 15px; font-weight: bold;height: 40px;display: table-cell; vertical-align: middle">-->
<!--                        {{shareTitle}}-->
<!--                    </div>-->
<!--                </van-cell>-->
                <van-row>
                    <van-col span="3" style="">
                        <van-image v-if="shareImg" :src="shareIcon" round style="width: 40px; height: 40px;" />
                    </van-col>
                    <van-col span="21">
                        <div style="font-size: 16px; font-weight: bold;height: 40px; line-height: 20px; display: table-cell; vertical-align: middle">
                            {{shareTitle}}
                        </div>
                    </van-col>
                </van-row>


            </div>
            <div>
                <van-row>
                    <van-col span="18">
                        <van-field
                                v-model="shareContent"
                                type="textarea"
                                readonly
                                :autosize="{maxHeight: 300, minHeight: 50}"
                                style="padding: 0px; font-size: 15px"
                        ></van-field>
                    </van-col>
                    <van-col span="6" style="text-align: right; padding-top: 5px;">
                        <van-button type="info"
                                    size="small"
                                    plain
                                    style="font-size: 14px"
                                    v-clipboard:copy="shareContent.replace('<br/>','\n')"
                                    v-clipboard:success="onCopySuccess"
                                    v-clipboard:error="onError">
                            复制文字
                        </van-button>
                    </van-col>
                </van-row>
            </div>
            <div style="margin-top: 10px">
                <div style="color: #ce9b0b; font-size: 16px">{{tip}}</div>
                <van-image v-if="shareImg" slot="icon" :src="shareImg" style="width: 80px; margin-top: 5px;" @click="makePoster"/>
            </div>

            <Wp_invite_by_qrcode :activeShow="show_share_pop"
                                 :wxUserInfo="wx_user_info"
                                 :newLink="qrcodeImgUrl"
                                 :shareImgUrl="shareImg"
                                 useTo="mini_app">
            </Wp_invite_by_qrcode>

            <van-popup v-model="showLoading">

                <van-loading type="spinner" color="#1989fa" vertical
                             style="padding: 30px;">
                    <div slot="default" style="text-align: center">海报制作中<br>&nbsp;请稍后...</div>
                </van-loading>

            </van-popup>
        </div>
    </div>
</template>

<script>
    import Wp_invite_by_qrcode from "./Wp_invite_by_qrcode";
    export default {
        name: "Wp_jd_share_model",
        components: {Wp_invite_by_qrcode},
        props:{
            shareIcon: {type: String, default: ""},
            shareTitle: {type: String, default: ""},
            shareContent: {type: String, default: ""},
            shareImg: {type: String, default: ""},
        },

        data(){
            return{
                tip: "#点击图片获取您的专属海报#",
                show_share_pop: "",
                wx_user_info: null,
                qrcodeImgUrl: "",

                showLoading: false,
            }
        },

        methods:{
            makePoster(){

                this.showLoading = true;
                this.getQrcodeUrl(()=>{

                    this.wx_user_info = this.$common.gloabl_wx_mini_user_info;

                    if(this.qrcodeImgUrl){
                        let timestamp = "_" + Date.parse(new Date());
                        this.show_share_pop = timestamp;
                    }
                    this.showLoading = false;
                })
            },

            getQrcodeUrl(fn){
                if(this.$common.gloabl_wx_mini_qr_img){
                    this.qrcodeImgUrl = this.$common.gloabl_wx_mini_qr_img;
                    if(fn){
                        fn();
                    }
                }else{
                    if(this.$common.gloabl_wx_mini_user_info){
                        let u_code = this.$common.gloabl_wx_mini_user_info.u_code;
                        let params = {
                            app_id: this.$common.wx_app_id,
                            app_secret: this.$common.wx_app_secret,
                            scene: u_code,
                            width: 300
                        };
                        this.$getWxAppQrcode(params, response =>{
                            this.$log(response)
                            if(response && response.data){
                                let qr_img_url = response.data;
                                if (qr_img_url) {
                                    this.qrcodeImgUrl = qr_img_url;
                                    this.$common.gloabl_wx_mini_qr_img = qr_img_url;

                                    if(fn){
                                        fn();
                                    }
                                }
                            }else{
                                this.showLoading = false;
                                this.$dialog.alert({
                                    message: "邀请海报制作失败，请重试"
                                })
                            }
                        })
                    }else{

                    }
                }


            },

            onCopySuccess() {

                // setTimeout(() => {
                //     this.$notify({
                //         message: '\n复制成功\n ',
                //         duration: 2000,
                //         background: '#1989fa'
                //     });
                //
                // }, 500);
                this.$toast.success({
                    message: "复制成功"
                })

            },

            onError() {

                // setTimeout(() => {
                //     this.$notify({
                //         message: '\n复制失败\n ',
                //         duration: 2000,
                //     });
                // }, 500);
                this.$toast.fail({
                    message: "复制失败"
                })
            },

            /**
             * 导航返回键
             */
            onClickBack(){
                this.$router.back();
            },
        }
    }
</script>

<style scoped>

</style>